<template>
  <div id="app" @click="isTimeout">
    <router-view  v-if="isRouterAlive"/>
    <loading></loading>
  </div>
</template>
<script>
import loading from "./components/loading";
export default {
  name: 'App',
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      isRouterAlive:true,
      lastTime:null, // 最后一次点击的时间
      currentTime: null, // 当前点击的时间
      timeOut:120 * 60 * 1000,// 设置超时时间
    }
  },
  created() {
    // 刷新页面重定向
    // if (this.$router.path !== "/Home") {
    //   this.$router.replace("/Home");
    // }
    // let token = sessionStorage.getItem('token')
    // console.log(token, 'token')
    // if(!token) {
    //   this.$router.push('/')
    // }
    this.lastTime = new Date().getTime()
  },
  methods:{
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function(){
        this.isRouterAlive = true;
      })
    },
    isTimeout () {
      this.currentTime = new Date().getTime();//记录这次点击的时间
      // 判断时间间隔是否大于两个小时
      if (this.currentTime - this.lastTime > this.timeOut) {
        if(sessionStorage.getItem('token') === 'token'){
          this.$router.push('/')
          sessionStorage.clear();
        }else {
          this.lastTime = new Date().getTime()
        }
      } else {
        this.lastTime = new Date().getTime()
      }
    }
  },
  components:{loading}
};
</script>
<style>
html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  overflow-y: hidden;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
body .el-table th.gutter {
  display: table-cell !important;
}
ul,li {
  margin: 0;
  padding: 0;
  list-style: none;
}
.el-table th,
.el-table td {
  text-align: center !important;
}
.el-table th,
.el-table td {
  padding: 0 !important;
  font-size: 14px !important;
}
.el-table th > .cell {
  background: #f7f7f7 !important;
  height: 41px !important;
  line-height: 41px !important;
  font-weight: 500 !important;
  color: #666666 !important;
}
.el-table td > .cell {
  background: #ffffff !important;
  height: 41px !important;
  line-height: 41px !important;
  color: #333333 !important;
}
.cascader .el-cascader-panel .el-radio{
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 10px;
  right: -10px;
}
.cascader .el-cascader-panel .el-radio__input {
  visibility: hidden;
}
.cascader .el-cascader-panel .el-cascader-node__postfix {
  top: 10px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4e70ad !important;
  color: #FFF;
}
.details {
    width: 0.453125rem;
    height: 0.15625rem;
    line-height: .15625rem;
    padding: 0!important;
    background: #4e70ad;
    color: #fff;
    font-size: .0625rem!important;
}
</style>
